import z from "zod";

/**
 * FuncionarioCopySchema
 */

export const FuncionarioCopySchema = z.object({
  dataAdmissao: z.coerce.date({ required_error: 'Este campo deve ser preenchido!', invalid_type_error: 'Este campo deve ser preenchido!' }),
  idCargo: z.coerce.number({ required_error: 'Este campo deve ser preenchido!', invalid_type_error: 'Este campo deve ser preenchido!' }),
  idCentroCusto: z.coerce.number({ required_error: 'Este campo deve ser preenchido!', invalid_type_error: 'Este campo deve ser preenchido!' }),
});

/**
 * FuncionarioCopyForm
 */

export type FuncionarioCopyForm = z.infer<typeof FuncionarioCopySchema>;